/**
 * Operator-facing customer label for egress-policy assignment surfaces
 * (#2512): `org_id · email`, or just `org_id` when email is missing.
 */
export function customerIdentity(orgId: string, email: string | null | undefined): string {
  const trimmed = typeof email === 'string' ? email.trim() : '';
  return trimmed.length > 0 ? `${orgId} · ${trimmed}` : orgId;
}

export function customerEmailOrNull(email: string | null | undefined): string | null {
  if (typeof email !== 'string') return null;
  const trimmed = email.trim();
  return trimmed.length > 0 ? trimmed : null;
}
